import * as React from 'react';
import { prop, isNil } from 'ramda';
import { isUndefined } from '@cian/newbuilding-utils';
import * as styles from './Select.css';
import { Button } from '../Button';
import { SelectionList } from '../SelectionList';

import { ClickOutside } from '../outside';
import { MountPopup } from '../PopupViewer';
import { Container } from '../Container';

export interface IVariants {
  id: string;
  label: string;
  isSubtitle?: boolean;
}

export interface ISelectProps {
  text?: string;
  placeholder: string;
  options: Array<IVariants>;
  onChange?(value: string): void;
  value?: string;
}

export interface ISelectState {
  selectedId?: string;
  isOpen?: boolean;
}

export class Select extends React.PureComponent<ISelectProps, ISelectState> {

  public state: Readonly<ISelectState> = {
    selectedId: this.props.value,
    isOpen: false,
  };
  public fakeSelect: HTMLSelectElement;

  public componentWillReceiveProps(nextProps: ISelectProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({selectedId: nextProps.value});
    }
  }

  public render() {
    const {
      text,
      options,
      placeholder,
    } = this.props;
    const { selectedId, isOpen } = this.state;
    const selectedVariant = this.getSelectedLabel();

    return (
      <label className={styles['hidden-select-handler']} data-mark="Select" data-style="select_component" >
        <select
          onChange={({currentTarget}) => this.handleChange({ id: currentTarget.value })}
          value={selectedId}
          ref={(select) => select && (this.fakeSelect = select)}
          className={styles['hidden-select']}
          tabIndex={-1}
        >
          {options.map(({label, id}) => (
            <option key={id} value={id}>{label}</option>
          ))}
        </select>

        <MountPopup
          placement="bottom"
          component={
            isOpen &&
            <ClickOutside onOutside={this.handleBlur}>
              <Container overflow="hidden" shadow>
                <div className={styles['list']}>
                  <SelectionList options={options} selectedItems={[selectedId]} onClick={this.handleChange} />
                </div>
              </Container>
            </ClickOutside>
          }
        >
          <Button
            type="light"
            normalText={true}
            icon={isOpen ? 'chevronUp' : 'chevronDown'}
            iconSize={10}
            reverse
            onClick={this.handleToggle}
            tabIndex={-1}
            className={isOpen ? styles['select-button-clicked'] : ''}
          >
            {isUndefined(text)
              ? selectedVariant
                ? prop('label', selectedVariant)
                : placeholder
              : text
            }
          </Button>
        </MountPopup>
      </label>
    );
  }

  private handleChange = ({ id }: { id: string, label?: string }) => {
    if (isNil(this.props.value)) { this.setState({selectedId: id}); }
    if (this.props.onChange) { this.props.onChange(id); }

    this.handleToggle();
  }

  private handleToggle = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  private handleBlur = () => {
    this.setState({ isOpen: false });
  }

  private getSelectedLabel(): IVariants | undefined {
    return this.props.options.find(({id}) => id === this.state.selectedId);
  }
}
